import { render, staticRenderFns } from "./KitCoverSkinDialog.vue?vue&type=template&id=74b775ef&scoped=true&"
import script from "./KitCoverSkinDialog.vue?vue&type=script&lang=ts&"
export * from "./KitCoverSkinDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b775ef",
  null
  
)

export default component.exports